export const hourSeparatorSign = '-';
export const removeSign = 'x';
export const addSign = '+';
